//检验方式
export const getInspectionMethod = (e: number) => {
    switch (e) {
        case 0:
            return '免检'
        case 1:
            return '抽检(减量)'
        case 2:
            return '抽检(正常)'
        case 3:
            return '抽检(加严)'
        case 4:
            return '全检'
    }
}

// 库位状态
export const localStatus = (e: number) => {
    switch (e) {        
        case 1:
            return "待入"
        case 2:
            return "存货"
        case 3:
            return "待出"
        case 4:
            return "锁定"
        case 0:
            return "空闲"
        case -1:
            return "禁用"
        case -10:
            return "全部"
    }
}
export const ordertype = (scope: number) => {
    switch (scope) {
        case 0:
            return "调拨单"
        case 1:
            return "手动单"
        case -10:
            return "全部"
    }
}
//手工入库单据状态
export const getStatus = (scope: number) => {
    switch (scope) {
        case 0:
            return "#1e90ff"
        case 1:
            return "#5352ed"
        case 2:
            return "#ff6348"
        case 3:
            return "#1e90ff"
        case 4:
            return "#5352ed"
        case 5:
            return "#ff6348"
    }
}
export const getText = (scope: number) => {
    switch (scope) {
        case 0:
            return "未执行"
        case 1:
            return "执行中"
        case 2:
            return "已完成"
        case 3:
            return "未发货"
        case 4:
            return "发货中"
        case 5:
            return "发货完成"
        case 6:
            return "执行完成"
    }
}
